/* ============================================================
   BucketGolf giveaway landing page - shared behaviour
   Vanilla JS, no dependencies. Loaded (deferred) by every
   giveaway-* section; the init guard makes it run once.

   What this file does NOT do, on purpose:
   - it never stores, calculates or displays a customer's entry
     balance. Entries are awarded by the giveaway system on the
     order / signup, never by this page.
   ============================================================ */
(function () {
  'use strict';
  if (window.__gwInit) return;
  window.__gwInit = true;

  /* ---------- analytics (Shopify custom pixels + GTM dataLayer) ---------- */
  function track(name, data) {
    var payload = data || {};
    payload.page = 'giveaway';
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* never break the page for analytics */ }
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: name };
      for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k)) dl[k] = payload[k];
      window.dataLayer.push(dl);
    } catch (e) { /* noop */ }
  }
  window.GWTrack = track;

  function datasetToPayload(el) {
    var out = {};
    var d = el.dataset;
    for (var k in d) {
      if (k.indexOf('gw') === 0 && k !== 'gwTrack') {
        var key = k.slice(2);
        key = key.charAt(0).toLowerCase() + key.slice(1);
        out[key] = d[k];
      }
    }
    return out;
  }

  /* ---------- helpers ---------- */
  function money(cents) {
    try {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, (theme.settings && theme.settings.moneyFormat) || '${{amount}}');
      }
    } catch (e) { /* fall through */ }
    return '$' + (cents / 100).toFixed(2);
  }

  function cartRefresh() {
    try {
      var isDrawer = !(window.theme && theme.settings && theme.settings.cartType === 'page');
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      if (isDrawer) {
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        }, 250);
      }
    } catch (e) { /* noop */ }
  }

  /* ---------- delegated clicks: tracking, scroll, add to cart ---------- */
  document.addEventListener('click', function (evt) {
    var t = evt.target.closest ? evt.target.closest('[data-gw-track],[data-gw-scroll],[data-gw-atc],[data-gw-faq-q]') : null;
    if (!t) return;

    if (t.hasAttribute('data-gw-track')) {
      track(t.getAttribute('data-gw-track'), datasetToPayload(t));
    }

    if (t.hasAttribute('data-gw-scroll')) {
      var href = t.getAttribute('href') || '';
      if (href.charAt(0) === '#' && href.length > 1) {
        var target = document.getElementById(href.slice(1));
        if (target) {
          evt.preventDefault();
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          try { history.replaceState(null, '', href); } catch (e) { /* noop */ }
        }
      }
    }

    if (t.hasAttribute('data-gw-atc')) {
      evt.preventDefault();
      addToCart(t);
    }

    if (t.hasAttribute('data-gw-faq-q')) {
      toggleFaq(t);
    }
  });

  function addToCart(btn) {
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId || btn.classList.contains('is-busy')) return;
    var label = btn.querySelector('[data-gw-atc-label]') || btn;
    var textDefault = btn.getAttribute('data-label-default') || label.textContent;
    var textAdding = btn.getAttribute('data-label-adding') || textDefault;
    var textAdded = btn.getAttribute('data-label-added') || textDefault;
    var errId = btn.getAttribute('data-error-el');
    var errEl = errId ? document.getElementById(errId) : null;
    var productUrl = btn.getAttribute('data-product-url') || '/cart';

    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    label.textContent = textAdding;
    if (errEl) errEl.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'cart'); });
      return res.json();
    }).then(function () {
      btn.classList.remove('is-busy');
      btn.classList.add('is-added');
      btn.removeAttribute('aria-busy');
      label.textContent = textAdded;
      track('giveaway_add_to_cart', datasetToPayload(btn));
      cartRefresh();
      setTimeout(function () {
        btn.classList.remove('is-added');
        label.textContent = textDefault;
      }, 2800);
    }).catch(function (err) {
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      label.textContent = textDefault;
      if (errEl) {
        var msg = (err && err.message && err.message !== 'cart') ? err.message : (btn.getAttribute('data-error-text') || 'Could not add to cart.');
        errEl.textContent = '';
        errEl.appendChild(document.createTextNode(msg + ' '));
        var a = document.createElement('a');
        a.href = productUrl;
        a.textContent = btn.getAttribute('data-error-link') || 'Open the product page';
        errEl.appendChild(a);
        errEl.hidden = false;
      }
    });
  }

  /* ---------- FAQ accordion ---------- */
  function toggleFaq(btn) {
    var item = btn.closest('.gwq__item');
    if (!item) return;
    var open = !item.classList.contains('is-open');
    var list = item.parentElement;
    if (list && list.getAttribute('data-gw-faq-single') === 'true') {
      Array.prototype.forEach.call(list.querySelectorAll('.gwq__item.is-open'), function (o) {
        if (o !== item) {
          o.classList.remove('is-open');
          var q = o.querySelector('[data-gw-faq-q]');
          if (q) q.setAttribute('aria-expanded', 'false');
        }
      });
    }
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) track('giveaway_faq_open', { question: (btn.textContent || '').trim().slice(0, 120) });
  }

  /* ---------- countdown (only when the merchant has set a real end date) ---------- */
  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-gw-countdown]');
    Array.prototype.forEach.call(nodes, function (box) {
      var raw = box.getAttribute('data-end');
      var end = raw ? new Date(raw) : null;
      if (!end || isNaN(end.getTime())) {
        var wrap = box.closest('[data-gw-deadline]');
        if (wrap) wrap.hidden = true;
        return;
      }
      var units = {
        d: box.querySelector('[data-gw-cd="d"]'),
        h: box.querySelector('[data-gw-cd="h"]'),
        m: box.querySelector('[data-gw-cd="m"]'),
        s: box.querySelector('[data-gw-cd="s"]')
      };
      var daysUnit = box.querySelector('[data-gw-cd-day-unit]');
      var closedText = box.getAttribute('data-closed-text') || 'Entries closed';
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) {
          box.innerHTML = '';
          var c = document.createElement('span');
          c.className = 'gwh__cd-closed';
          c.textContent = closedText;
          box.appendChild(c);
          clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        if (units.d) units.d.textContent = d;
        if (daysUnit) daysUnit.style.display = d === 0 ? 'none' : '';
        if (units.h) units.h.textContent = pad(h);
        if (units.m) units.m.textContent = pad(m);
        if (units.s) units.s.textContent = pad(s);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------- sticky mobile bar: shows once the hero has scrolled away ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-gw-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var watchSel = bar.getAttribute('data-watch');
    var watch = watchSel ? document.querySelector(watchSel) : null;
    var stopSel = bar.getAttribute('data-stop');
    var stop = stopSel ? document.querySelector(stopSel) : null;
    if (!watch) return;
    var heroGone = false, stopVisible = false;
    function paint() { bar.classList.toggle('is-on', heroGone && !stopVisible); }
    new IntersectionObserver(function (entries) {
      heroGone = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
      paint();
    }, { threshold: 0 }).observe(watch);
    if (stop) {
      new IntersectionObserver(function (entries) {
        stopVisible = entries[0].isIntersecting;
        paint();
      }, { threshold: 0.15 }).observe(stop);
    }
  }

  /* ---------- reveal on scroll (subtle, respects reduced motion) ---------- */
  function initReveal() {
    var nodes = document.querySelectorAll('[data-gw-reveal]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  /* ---------- email signup: real Shopify customer form, we only track the submit ---------- */
  function initSignup() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gw-signup]'), function (node) {
      var form = node.tagName === 'FORM' ? node : node.querySelector('form');
      if (!form || form.__gwBound) return;
      form.__gwBound = true;
      form.addEventListener('submit', function () {
        track('giveaway_signup_submit', { source: node.getAttribute('data-gw-signup') || 'giveaway' });
      });
    });
    var ok = document.querySelector('[data-gw-signup-success]');
    if (ok) {
      track('giveaway_signup_success', { source: ok.getAttribute('data-gw-signup-success') || 'giveaway' });
      try { ok.scrollIntoView({ block: 'center' }); } catch (e) { /* noop */ }
    }
  }

  /* ---------- video clips: tap to play with sound, one at a time, never autoplay ---------- */
  var activeVideo = null;
  function initVideos() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-gw-video]'), function (box) {
      if (box.__gwVideo) return;
      var v = box.querySelector('video');
      if (!v) return;
      box.__gwVideo = true;
      v.setAttribute('playsinline', '');
      v.removeAttribute('autoplay');
      v.loop = false;
      var muteBtn = box.querySelector('.gwv__mute');
      var idx = box.getAttribute('data-gw-index') || '';

      function pauseOthers() {
        if (activeVideo && activeVideo !== v) { activeVideo.pause(); }
      }
      function play() {
        pauseOthers();
        activeVideo = v;
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* user can tap again */ });
      }
      box.addEventListener('click', function (evt) {
        if (muteBtn && (evt.target === muteBtn || muteBtn.contains(evt.target))) return;
        if (v.paused) {
          if (!box.classList.contains('is-started')) track('giveaway_video_play', { clip: idx });
          play();
        } else {
          v.pause();
        }
      });
      v.addEventListener('play', function () { box.classList.add('is-playing', 'is-started'); });
      v.addEventListener('pause', function () { box.classList.remove('is-playing'); });
      v.addEventListener('ended', function () {
        box.classList.remove('is-playing');
        track('giveaway_video_complete', { clip: idx });
        try { v.currentTime = 0; } catch (e) { /* noop */ }
      });
      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          v.muted = !v.muted;
          muteBtn.setAttribute('aria-pressed', v.muted ? 'true' : 'false');
        });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting && !v.paused) v.pause();
        }, { threshold: 0.2 }).observe(box);
      }
    });
  }

  /* ---------- section view tracking ---------- */
  function initViews() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          track('giveaway_section_view', { section: en.target.getAttribute('data-gw-section') });
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.35 });
    Array.prototype.forEach.call(document.querySelectorAll('[data-gw-section]'), function (n) { io.observe(n); });
  }

  function init() {
    initCountdowns();
    initSticky();
    initReveal();
    initSignup();
    initVideos();
    initViews();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function () { initCountdowns(); initSticky(); initReveal(); initVideos(); });
})();
